import { Location } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { SendCommandDto } from 'src/app/model/qModel.model';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { CommonEnums } from 'src/app/utils/enum-utils';
declare var $: any
@Component({
  selector: 'app-security-score',
  templateUrl: './security-score.component.html',
})
export class SecurityScoreComponent implements OnInit, AfterViewInit {

  isMobile: boolean = true;
  isOTP: boolean = false;
  isDone: boolean = false;
  isOwnership: boolean = true;
  isSubmitted = false;
  mobileNumber: any
  loggedInUser: any;
  addUserErrorMessage: any;
  sendCommanddto: SendCommandDto = new SendCommandDto();
  childData: any
  selectedLanguage: any
  userResponse: any = [];
  selectedIndex: number = 0;
  getFirstIndexData: any;
  enableGridView: boolean = false;
  isGridView: boolean = true;
  isTreeView: boolean = false;
  s3Url: any;
  noDeviceFount: boolean = false;
  deleteUserResponseMessage: any;
  deleteSuccess: boolean = false;
  // isLoading: boolean = false;
  syncScoreArr: any = []
  ScoreManagementData: any[] = []
  apiUrl: any;
  color: any;
  securityColor: any;
  securityScoreStatus: any;
  privacyScoreStatus: any;
  Securitystringstatus: any;
  Privacystringstatus: any;
  securityStatusBg: string = '';
  securityStatusClr: string = '';
  privacyStatusBg: string = '';
  privacyStatusClr: string = '';
  userName: string = '';
  name: string = '';
  lastUpdatedDate: any;
  productVersion: any;
  ngAfterViewInit() {
    this.selectedIndex = 0;
  }
  isLoading: boolean = false;
  openMyDeviceContent: boolean = false;
  openUserDeviceContent: boolean = false;
  needleValueSecurity: number = 0;
  privacyScore: number = 0;
  privacyTotalScore: number = 0;
  security_rot_deg: number = 0;
  privacy_rot_deg: number = 0;
  securityScoreIcon: String;
  privacyScoreIcon: String;
  securityScore: number = 0;
  securityTotalScore: number = 0;
  lastSyncDate: any;
  privacyRecommendations: any[] = [];
  securityRecommendations: any[] = [];

  deviceId: string = ''
  deviceName: string = ''
  delimitervalue: number = 1;
  delimiterPrivacyvalue: number = 1;
  public canvasWidth = 300
  public needleValue = 0
  public centralLabel = '';
  options = {};
  userId: any;
  options1 = {};
  getDeviceId: string = '';
  devicesList: any[] = [];
  SCORE: string;
  productKeyType: any;
  restorePublishForm: FormGroup = new FormGroup({
    mobileDeviceName: new FormControl('')
  })
  privacy_score: any;
  security_score: any;
  screenWidth: any;
  userTimezone: string;
  constructor(private formBuilder: FormBuilder, private _router: Router, private _service: ApiService, private _actRout: ActivatedRoute,
    private location: Location, private _toastr: ToastrService, private translate: TranslateService, private commonService: CommonService) {
    this.commonService.privacyscore.subscribe((privacyscore) => {
      this.privacy_score = privacyscore && privacyscore != null ? JSON.parse(privacyscore) : 0;
    })

    this.commonService.securityscore.subscribe((securityscore) => {
      this.security_score = securityscore && securityscore != null ? JSON.parse(securityscore) : 0;
    })
  }
  ngOnInit(): void {
    this.userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    this.enableGridView = true;
    scrollTo(0, 0)
    let currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      this.loggedInUser = JSON.parse(currentUser);
    }
    this.screenWidth = window.screen.width;
    this.selectedIndex = 0;
    this.deviceId = this._actRout.snapshot.params["id"];
    this.userId = this._actRout.snapshot.queryParams["userId"];

    this.SCORE = this.translate.instant('SCOREMANAGEMENT.SCORE');

    this.openMyDeviceContent = true;
    this.getSystemMobileData();
  }
  openTabs(deviceType: any) {
    if (deviceType === 'MYDEVICE') {
      this.openMyDeviceContent = true;
      this.openUserDeviceContent = false;
    } else {
      this.openMyDeviceContent = false;
      this.openUserDeviceContent = true;
    }
  }
  goBack() {
    this.location.back()
  }
  mblDeviceTypeOnChange() {
    if (this.screenWidth > 768) {
      if (this.privacy_score === 0 && this.security_score === 0) {
        this.margins = "145px auto";
      } else if ((this.privacy_score > 0 && this.privacy_score <= 800) && (this.security_score > 0 && this.security_score <= 800)) {
        this.margins = "145px auto"
      } else {
        this.margins = "190px auto"
      }
    }
  }


  margins: any;
  statusBg: string = '';
  statusClr: string = '';
  statusprivacyBg: string = '';
  statusPrivacyClr: string = '';
  getDashboardDataById(deviceId: any) {
    this.isLoading = true;
    this.getDeviceId = deviceId;
    this.privacyRecommendations = [];
    this.securityRecommendations = [];
    this.needleValueSecurity = 0;
    this.privacyScore = 0;
    this.privacyTotalScore = 0;
    this.securityScore = 0;
    this.securityTotalScore = 0;
    this.security_rot_deg = 0;
    this.privacy_rot_deg = 0;
    this.delimiterPrivacyvalue = 0;
    this._service.getService(this._service.API_URL.getDashboardDataById + deviceId).subscribe((response) => {
      if (response && response.status.code === 200) {
        this.isLoading = false;
        this.privacyScore = response.data.privacyScore;
        this.privacyTotalScore = response.data.privacyTotalScore;
        this.privacy_rot_deg = (response.data.privacyScore * 180) / response.data.privacyTotalScore;
        this.securityScore = response.data.securityScore;
        this.security_rot_deg = (response.data.securityScore * 180) / response.data.securityTotalScore;
        this.securityTotalScore = response.data.securityTotalScore;
        this.privacyRecommendations = response.data.privacyRecommendations;
        this.securityRecommendations = response.data.securityRecommendations;
        this.deviceName = response.data.name;
        this.delimiterPrivacyvalue = (response.data.privacyScore / 10);
        this.needleValueSecurity = (response.data.securityScore / 10);
        this.securityScoreStatus = response.data.securityScoreStatus;
        this.privacyScoreStatus = response.data.privacyScoreStatus;
        this.productKeyType = response.data.deviceType;
        this.lastSyncDate = response.data.lastSyncDate;
        this.lastUpdatedDate = response.data.lastUpdatedDate;
        if (this.productKeyType == "SYSTEM") {
          this.margins = '12px auto';
        } else {
          this.mblDeviceTypeOnChange();
        }
        if (this.delimiterPrivacyvalue >= 100) {
          this.delimiterPrivacyvalue = 99.9;
        }

        this.privacyScoreStatus = response.data.privacyScoreStatus;
        if (this.privacyScore <= 250) {
          this.color = '#FF4B2B'
          this.Privacystringstatus = this.translate.instant('SCORE.PRIVACY.LOW');
        } else if (this.privacyScore >= 251 && this.privacyScore <= 500) {
          this.color = '#FB6C6C'
          this.Privacystringstatus = this.translate.instant('SCORE.PRIVACY.MEDIUM');
        } else if (this.privacyScore >= 501 && this.privacyScore <= 800) {
          this.color = '#F59E0B'
          this.Privacystringstatus = this.translate.instant('SCORE.PRIVACY.GOOD');
        } else {
          this.color = '#1ECB1A'
          this.Privacystringstatus = this.translate.instant('SCORE.PRIVACY.EXCELLENT');
        }
        if (this.privacyScore >= 50) {
          this.securityColor = 'rgb(58, 215, 55, 1)'
        } else {
          this.securityColor = 'rgb(255, 65, 65, 1)'
        }
        this.options1 = {
          hasNeedle: true,
          needleColor: '#023047',
          needleUpdateSpeed: 1000,
          arcColors: [this.color, 'lightgray'],
          arcDelimiters: [this.delimiterPrivacyvalue ? this.delimiterPrivacyvalue : 1],
          needleStartValue: 0.1,
        }
        if (this.privacyScore <= 250) {
          this.privacyStatusBg = "#DC392F";
          this.privacyStatusClr = "#DC392F";
          this.privacyScoreIcon = CommonEnums.LOWSCOREICON;

        } else if (this.privacyScore >= 251 && this.privacyScore <= 500) {
          this.privacyStatusBg = "#FAA200";
          this.privacyStatusClr = "#FAA200";
          this.privacyScoreIcon = CommonEnums.MEDIUMSCOREICON;
        } else if (this.privacyScore >= 501 && this.privacyScore <= 800) {
          this.privacyStatusBg = "#2144FE";
          this.privacyStatusClr = "#2144FE";
          this.privacyScoreIcon = CommonEnums.GOODSCOREICON;
        } else {
          this.privacyStatusBg = "#0DA437";
          this.privacyStatusClr = "#1ECB1A";
          this.privacyScoreIcon = CommonEnums.EXCELLENTSCOREICON;
        }
        this.delimitervalue = (response.data.securityScore / 10);
        if (this.delimitervalue >= 100) {
          this.delimitervalue = 99.9;
        }

        this.securityScoreStatus = response.data.securityScoreStatus;
        if (this.securityScore <= 250) {
          this.color = '#FF4B2B'
          this.Securitystringstatus = this.translate.instant('SCORE.SECURITY.LOW');
        } else if (this.securityScore >= 251 && this.securityScore <= 500) {
          this.color = '#FB6C6C'
          this.Securitystringstatus = this.translate.instant('SCORE.SECURITY.MEDIUM');
        } else if (this.securityScore >= 501 && this.securityScore <= 800) {
          this.color = '#F59E0B'
          this.Securitystringstatus = this.translate.instant('SCORE.SECURITY.GOOD');
        } else {
          this.color = '#1ECB1A'
          this.Securitystringstatus = this.translate.instant('SCORE.SECURITY.EXCELLENT');
        }
        if (this.securityScore >= 50) {
          this.securityColor = 'rgb(58, 215, 55, 1)'
        } else {
          this.securityColor = 'rgb(255, 65, 65, 1)'
        }
        this.options = {
          hasNeedle: true,
          needleColor: '#023047',
          needleUpdateSpeed: 1000,
          arcColors: [this.color, 'lightgray'],
          arcDelimiters: [this.delimitervalue ? this.delimitervalue : 1],
          needleStartValue: 0.1,
        }
        if (this.securityScore <= 250) {
          this.securityStatusBg = "#FDDDDD";
          this.securityStatusClr = "#DC392F";
          this.securityScoreIcon = CommonEnums.LOWSCOREICON;
        } else if (this.securityScore >= 251 && this.securityScore <= 500) {
          this.securityStatusBg = "#FFF0F0";
          this.securityStatusClr = "#FAA200";
          this.securityScoreIcon = CommonEnums.MEDIUMSCOREICON;
        } else if (this.securityScore >= 501 && this.securityScore <= 800) {
          this.securityStatusBg = "#FDECCE";
          this.securityStatusClr = "#2144FE";
          this.securityScoreIcon = CommonEnums.GOODSCOREICON;
        } else {
          this.securityStatusBg = "#D5FED6";
          this.securityStatusClr = "#1ECB1A";
          this.securityScoreIcon = CommonEnums.EXCELLENTSCOREICON;
        }
      } else {
        this.isLoading = false;
        this._toastr.error('', response.message);
      }
    })
  }

  getSystemMobileData() {
    this.isLoading = true;
    this.devicesList = []; this.productKeyType = ''
    try {
      if (this.userId === undefined) {
        this.apiUrl = `${this._service.API_URL.getSystemMobileData}?timezone=${encodeURIComponent(this.userTimezone)}&selectedLang=${encodeURIComponent(this.selectedLanguage)}`;
      } else {
        this.apiUrl = `${this._service.API_URL.getSystemMobileData}?userId=${encodeURIComponent(this.userId)}&timezone=${encodeURIComponent(this.userTimezone)}&selectedLang=${encodeURIComponent(this.selectedLanguage)}`;
      }
      this._service.getService(this.apiUrl).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.devicesList = response.data;
          if (this.deviceId) {
            this.devicesList.forEach(element => {
              this.productKeyType = element.deviceType;
              if (this.deviceId == element.id) {
                this.getDashboardDataById(element.id)
                this.deviceName = element.deviceName;
                this.name = element.name;
                this.restorePublishForm.controls['mobileDeviceName'].setValue(element.id);
              }
            }
            );
          } else {
            this.restorePublishForm.controls['mobileDeviceName'].setValue(this.devicesList[0]?.id);
          }
        } else {
          this.isLoading = false;
          this._toastr.error('', response.message);
        }
      })
    } catch (error: any) {
      this.isLoading = false;
      this._toastr.error('', error);
    }
  }

  onMobileDeviceSelect(evt: any) {
    this.deviceId = evt;
    this.getDashboardDataById(this.deviceId)
  }


  openSyncScoreModal(id: any, type: any) {
    this.syncScoreArr = [];
    this.syncScoreArr.push(id, type);
    this.productVersion = this.devicesList.filter(device => device.id == id).map(i => i.productVersion);

    if (this.productVersion >= "4.00.02") {
      this.sendCommandScore(id, 'UPDATE_ALL_DETAILS');
    } else {
      //this.sendCommandScore(id, 'UPDATE_ALL_DETAILS');
      this.sendCommandScore(id, 'SCORE');
    }
  }


  sendCommandScore(id: any, type: any) {
    this.isLoading = true;
    try {
      this.sendCommanddto.deviceId = id;
      this.sendCommanddto.mobileNo = this.mobileNumber;
      this.sendCommanddto.productKeyType = this.productKeyType;
      this.sendCommanddto.requestType = type;
      this.sendCommanddto.systemRequestType = type;
      this._service.postService(this._service.API_URL.sendCommand, this.sendCommanddto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this._toastr.success('', response.status.message);
        } else {
          this.isLoading = false;
          this._toastr.error('', response.status.message);
        }
      })
    } catch (error: any) {
      this.isLoading = false;
      this._toastr.error('', error);
    }
  }
}
